/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { DropDownItem } from "../models/drop-down-item";
import { ManagedSubscription } from "../models/managed-subscription";
import { SubscriptionsUsersViewModel } from "../models/subscriptions-users-view-model";
import { SubscriptionGroupViewModel } from "../models/subscription-group-view-model";
import { SubscriptionPaymentTrackerId } from "../models/subscription-payment-tracker-id";
import { SubscriptionPurchaseViewModel } from "../models/subscription-purchase-view-model";
import { SubscriptionRenewViewModel } from "../models/subscription-renew-view-model";
import { SubscriptionPaymentTracker } from "../models/subscription-payment-tracker";
import { UpdateUserSubscriptionRequest } from "../models/update-user-subscription-request";
import { UserState } from "../models/user-state";
import { US_Bookmark } from "../models/us_bookmark";
import { US_Filter } from "../models/us_filter";
import { US_ReportExport } from "../models/us_report-export";
@Injectable({
  providedIn: "root",
})
class SubscriptionService extends __BaseService {
  static readonly subscriptionGetInteractiveSubscriptionsPath =
    "/api/Subscription/GetInteractiveSubscriptions";
  static readonly subscriptionGetManagedSubscriptionsPath =
    "/api/Subscription/GetManagedSubscriptions";
  static readonly subscriptionGetSubscriptionUserViewModelPath =
    "/api/Subscription/GetSubscriptionUserViewModel";
  static readonly subscriptionGetSubscriptionGroupsPath =
    "/api/Subscription/GetSubscriptionGroups";
  static readonly subscriptionUpdateSubscriptionGroupsPath =
    "/api/Subscription/UpdateSubscriptionGroups";
  static readonly subscriptionGetCouponCodeDiscountPath =
    "/api/Subscription/GetCouponCodeDiscount";
  static readonly subscriptionGetTaxAmountPath =
    "/api/Subscription/GetTaxAmount";
  static readonly subscriptionGetSubscriptionIsReportPath =
    "/api/Subscription/GetSubscriptionIsReport";
  static readonly subscriptionPurchaseSubscriptionPath =
    "/api/Subscription/PurchaseSubscription";
  static readonly subscriptionRenewSubscriptionPath =
    "/api/Subscription/RenewSubscription";
  static readonly subscriptionTrackSubscriptionPaymentPath =
    "/api/Subscription/TrackSubscriptionPayment";
  static readonly subscriptionSubcriptionPaymentReturnPath =
    "/api/Subscription/SubcriptionPaymentReturn";
  static readonly subscriptionSubscriptionPaymentErrorPath =
    "/api/Subscription/SubscriptionPaymentError";
  static readonly subscriptionActivateAutoRenewPath =
    "/api/Subscription/ActivateAutoRenew";
  static readonly subscriptionCancelAutoRenewPath =
    "/api/Subscription/CancelAutoRenew";
  static readonly subscriptionUpdateAutoRenewCardPath =
    "/api/Subscription/UpdateAutoRenewCard";
  static readonly subscriptionProcessAutoRenewPaymentsPath =
    "/api/Subscription/ProcessAutoRenewPayments";
  static readonly subscriptionUpdateUserSubscriptionPath =
    "/api/Subscription/UpdateUserSubscription";
  static readonly subscriptionSendSubscriptionInvitationEmailPath =
    "/api/Subscription/SendSubscriptionInvitationEmail";
  static readonly subscriptionUpdateUsersSubscriptionPath =
    "/api/Subscription/UpdateUsersSubscription";
  static readonly subscriptionGetUserSubscriptionStatePath =
    "/api/Subscription/GetUserSubscriptionState";
  static readonly subscriptionGetSubscriptionSubStateBookmarksPath =
    "/api/Subscription/GetSubscriptionSubState_Bookmarks";
  static readonly subscriptionGetSubscriptionSubStateFiltersPath =
    "/api/Subscription/GetSubscriptionSubState_Filters";
  static readonly subscriptionGetSubscriptionSubStateReportExportsPath =
    "/api/Subscription/GetSubscriptionSubState_ReportExports";
  static readonly subscriptionClearAllCachePath =
    "/api/Subscription/ClearAllCache";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  subscriptionGetInteractiveSubscriptionsResponse(): __Observable<
    __StrictHttpResponse<Array<DropDownItem>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetInteractiveSubscriptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DropDownItem>>;
      })
    );
  }
  subscriptionGetInteractiveSubscriptions(): __Observable<Array<DropDownItem>> {
    return this.subscriptionGetInteractiveSubscriptionsResponse().pipe(
      __map((_r) => _r.body as Array<DropDownItem>)
    );
  }
  subscriptionGetManagedSubscriptionsResponse(): __Observable<
    __StrictHttpResponse<Array<ManagedSubscription>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetManagedSubscriptions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ManagedSubscription>>;
      })
    );
  }
  subscriptionGetManagedSubscriptions(): __Observable<
    Array<ManagedSubscription>
  > {
    return this.subscriptionGetManagedSubscriptionsResponse().pipe(
      __map((_r) => _r.body as Array<ManagedSubscription>)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  subscriptionGetSubscriptionUserViewModelResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<SubscriptionsUsersViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetSubscriptionUserViewModel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubscriptionsUsersViewModel>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  subscriptionGetSubscriptionUserViewModel(
    subscriptionId?: number
  ): __Observable<SubscriptionsUsersViewModel> {
    return this.subscriptionGetSubscriptionUserViewModelResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as SubscriptionsUsersViewModel));
  }

  /**
   * @param subscriptionId undefined
   */
  subscriptionGetSubscriptionGroupsResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<SubscriptionGroupViewModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetSubscriptionGroups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SubscriptionGroupViewModel>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  subscriptionGetSubscriptionGroups(
    subscriptionId?: number
  ): __Observable<Array<SubscriptionGroupViewModel>> {
    return this.subscriptionGetSubscriptionGroupsResponse(subscriptionId).pipe(
      __map((_r) => _r.body as Array<SubscriptionGroupViewModel>)
    );
  }

  /**
   * @param viewModels undefined
   */
  subscriptionUpdateSubscriptionGroupsResponse(
    viewModels: Array<SubscriptionGroupViewModel>
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = viewModels;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/UpdateSubscriptionGroups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param viewModels undefined
   */
  subscriptionUpdateSubscriptionGroups(
    viewModels: Array<SubscriptionGroupViewModel>
  ): __Observable<boolean> {
    return this.subscriptionUpdateSubscriptionGroupsResponse(viewModels).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `SubscriptionService.SubscriptionGetCouponCodeDiscountParams` containing the following parameters:
   *
   * - `subscriptionTypeId`:
   *
   * - `subscriptionType`:
   *
   * - `subscriptionLevelId`:
   *
   * - `periodTypeId`:
   *
   * - `couponCode`:
   */
  subscriptionGetCouponCodeDiscountResponse(
    params: SubscriptionService.SubscriptionGetCouponCodeDiscountParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subscriptionTypeId != null)
      __params = __params.set(
        "subscriptionTypeId",
        params.subscriptionTypeId.toString()
      );
    if (params.subscriptionType != null)
      __params = __params.set(
        "subscriptionType",
        params.subscriptionType.toString()
      );
    if (params.subscriptionLevelId != null)
      __params = __params.set(
        "subscriptionLevelId",
        params.subscriptionLevelId.toString()
      );
    if (params.periodTypeId != null)
      __params = __params.set("periodTypeId", params.periodTypeId.toString());
    if (params.couponCode != null)
      __params = __params.set("couponCode", params.couponCode.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetCouponCodeDiscount`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `SubscriptionService.SubscriptionGetCouponCodeDiscountParams` containing the following parameters:
   *
   * - `subscriptionTypeId`:
   *
   * - `subscriptionType`:
   *
   * - `subscriptionLevelId`:
   *
   * - `periodTypeId`:
   *
   * - `couponCode`:
   */
  subscriptionGetCouponCodeDiscount(
    params: SubscriptionService.SubscriptionGetCouponCodeDiscountParams
  ): __Observable<number> {
    return this.subscriptionGetCouponCodeDiscountResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param params The `SubscriptionService.SubscriptionGetTaxAmountParams` containing the following parameters:
   *
   * - `subTotal`:
   *
   * - `stateCode`:
   */
  subscriptionGetTaxAmountResponse(
    params: SubscriptionService.SubscriptionGetTaxAmountParams
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subTotal != null)
      __params = __params.set("subTotal", params.subTotal.toString());
    if (params.stateCode != null)
      __params = __params.set("stateCode", params.stateCode.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetTaxAmount`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param params The `SubscriptionService.SubscriptionGetTaxAmountParams` containing the following parameters:
   *
   * - `subTotal`:
   *
   * - `stateCode`:
   */
  subscriptionGetTaxAmount(
    params: SubscriptionService.SubscriptionGetTaxAmountParams
  ): __Observable<number> {
    return this.subscriptionGetTaxAmountResponse(params).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  subscriptionGetSubscriptionIsReportResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetSubscriptionIsReport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  subscriptionGetSubscriptionIsReport(
    subscriptionId?: number
  ): __Observable<boolean> {
    return this.subscriptionGetSubscriptionIsReportResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as boolean));
  }

  /**
   * @param subscriptionDetails undefined
   */
  subscriptionPurchaseSubscriptionResponse(
    subscriptionDetails: SubscriptionPurchaseViewModel
  ): __Observable<__StrictHttpResponse<SubscriptionPaymentTrackerId>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = subscriptionDetails;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/PurchaseSubscription`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubscriptionPaymentTrackerId>;
      })
    );
  }
  /**
   * @param subscriptionDetails undefined
   */
  subscriptionPurchaseSubscription(
    subscriptionDetails: SubscriptionPurchaseViewModel
  ): __Observable<SubscriptionPaymentTrackerId> {
    return this.subscriptionPurchaseSubscriptionResponse(
      subscriptionDetails
    ).pipe(__map((_r) => _r.body as SubscriptionPaymentTrackerId));
  }

  /**
   * @param subscriptionDetails undefined
   */
  subscriptionRenewSubscriptionResponse(
    subscriptionDetails: SubscriptionRenewViewModel
  ): __Observable<__StrictHttpResponse<SubscriptionPaymentTrackerId>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = subscriptionDetails;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/RenewSubscription`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubscriptionPaymentTrackerId>;
      })
    );
  }
  /**
   * @param subscriptionDetails undefined
   */
  subscriptionRenewSubscription(
    subscriptionDetails: SubscriptionRenewViewModel
  ): __Observable<SubscriptionPaymentTrackerId> {
    return this.subscriptionRenewSubscriptionResponse(subscriptionDetails).pipe(
      __map((_r) => _r.body as SubscriptionPaymentTrackerId)
    );
  }

  /**
   * @param trackerId undefined
   */
  subscriptionTrackSubscriptionPaymentResponse(
    trackerId: SubscriptionPaymentTrackerId
  ): __Observable<__StrictHttpResponse<SubscriptionPaymentTracker>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = trackerId;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/TrackSubscriptionPayment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubscriptionPaymentTracker>;
      })
    );
  }
  /**
   * @param trackerId undefined
   */
  subscriptionTrackSubscriptionPayment(
    trackerId: SubscriptionPaymentTrackerId
  ): __Observable<SubscriptionPaymentTracker> {
    return this.subscriptionTrackSubscriptionPaymentResponse(trackerId).pipe(
      __map((_r) => _r.body as SubscriptionPaymentTracker)
    );
  }
  subscriptionSubcriptionPaymentReturnResponse(): __Observable<
    __StrictHttpResponse<Blob>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/SubcriptionPaymentReturn`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  subscriptionSubcriptionPaymentReturn(): __Observable<Blob> {
    return this.subscriptionSubcriptionPaymentReturnResponse().pipe(
      __map((_r) => _r.body as Blob)
    );
  }
  subscriptionSubscriptionPaymentErrorResponse(): __Observable<
    __StrictHttpResponse<Blob>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/SubscriptionPaymentError`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  subscriptionSubscriptionPaymentError(): __Observable<Blob> {
    return this.subscriptionSubscriptionPaymentErrorResponse().pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  subscriptionActivateAutoRenewResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/ActivateAutoRenew`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  subscriptionActivateAutoRenew(
    subscriptionId?: number
  ): __Observable<boolean> {
    return this.subscriptionActivateAutoRenewResponse(subscriptionId).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  subscriptionCancelAutoRenewResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/CancelAutoRenew`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  subscriptionCancelAutoRenew(subscriptionId?: number): __Observable<boolean> {
    return this.subscriptionCancelAutoRenewResponse(subscriptionId).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param params The `SubscriptionService.SubscriptionUpdateAutoRenewCardParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `expYear`:
   *
   * - `expMonth`:
   *
   * - `ccv`:
   *
   * - `cc`:
   */
  subscriptionUpdateAutoRenewCardResponse(
    params: SubscriptionService.SubscriptionUpdateAutoRenewCardParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subscriptionId != null)
      __params = __params.set(
        "subscriptionId",
        params.subscriptionId.toString()
      );
    if (params.expYear != null)
      __params = __params.set("expYear", params.expYear.toString());
    if (params.expMonth != null)
      __params = __params.set("expMonth", params.expMonth.toString());
    if (params.ccv != null)
      __params = __params.set("ccv", params.ccv.toString());
    if (params.cc != null) __params = __params.set("cc", params.cc.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/UpdateAutoRenewCard`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `SubscriptionService.SubscriptionUpdateAutoRenewCardParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `expYear`:
   *
   * - `expMonth`:
   *
   * - `ccv`:
   *
   * - `cc`:
   */
  subscriptionUpdateAutoRenewCard(
    params: SubscriptionService.SubscriptionUpdateAutoRenewCardParams
  ): __Observable<boolean> {
    return this.subscriptionUpdateAutoRenewCardResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }
  subscriptionProcessAutoRenewPaymentsResponse(): __Observable<
    __StrictHttpResponse<boolean>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/ProcessAutoRenewPayments`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  subscriptionProcessAutoRenewPayments(): __Observable<boolean> {
    return this.subscriptionProcessAutoRenewPaymentsResponse().pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param request undefined
   */
  subscriptionUpdateUserSubscriptionResponse(
    request: UpdateUserSubscriptionRequest
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/UpdateUserSubscription`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  subscriptionUpdateUserSubscription(
    request: UpdateUserSubscriptionRequest
  ): __Observable<string> {
    return this.subscriptionUpdateUserSubscriptionResponse(request).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param params The `SubscriptionService.SubscriptionSendSubscriptionInvitationEmailParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `subUserId`:
   */
  subscriptionSendSubscriptionInvitationEmailResponse(
    params: SubscriptionService.SubscriptionSendSubscriptionInvitationEmailParams
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subscriptionId != null)
      __params = __params.set(
        "subscriptionId",
        params.subscriptionId.toString()
      );
    if (params.subUserId != null)
      __params = __params.set("subUserId", params.subUserId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/SendSubscriptionInvitationEmail`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `SubscriptionService.SubscriptionSendSubscriptionInvitationEmailParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `subUserId`:
   */
  subscriptionSendSubscriptionInvitationEmail(
    params: SubscriptionService.SubscriptionSendSubscriptionInvitationEmailParams
  ): __Observable<null> {
    return this.subscriptionSendSubscriptionInvitationEmailResponse(
      params
    ).pipe(__map((_r) => _r.body as null));
  }

  /**
   * @param request undefined
   */
  subscriptionUpdateUsersSubscriptionResponse(
    request: UpdateUserSubscriptionRequest
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Subscription/UpdateUsersSubscription`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param request undefined
   */
  subscriptionUpdateUsersSubscription(
    request: UpdateUserSubscriptionRequest
  ): __Observable<string> {
    return this.subscriptionUpdateUsersSubscriptionResponse(request).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param userId undefined
   */
  subscriptionGetUserSubscriptionStateResponse(
    userId?: number
  ): __Observable<__StrictHttpResponse<UserState>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (userId != null) __params = __params.set("userId", userId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetUserSubscriptionState`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserState>;
      })
    );
  }
  /**
   * @param userId undefined
   */
  subscriptionGetUserSubscriptionState(
    userId?: number
  ): __Observable<UserState> {
    return this.subscriptionGetUserSubscriptionStateResponse(userId).pipe(
      __map((_r) => _r.body as UserState)
    );
  }

  /**
   * @param interactiveId undefined
   */
  subscriptionGetSubscriptionSubStateBookmarksResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<US_Bookmark>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetSubscriptionSubState_Bookmarks`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<US_Bookmark>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  subscriptionGetSubscriptionSubStateBookmarks(
    interactiveId?: number
  ): __Observable<Array<US_Bookmark>> {
    return this.subscriptionGetSubscriptionSubStateBookmarksResponse(
      interactiveId
    ).pipe(__map((_r) => _r.body as Array<US_Bookmark>));
  }

  /**
   * @param interactiveId undefined
   */
  subscriptionGetSubscriptionSubStateFiltersResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<US_Filter>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetSubscriptionSubState_Filters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<US_Filter>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  subscriptionGetSubscriptionSubStateFilters(
    interactiveId?: number
  ): __Observable<Array<US_Filter>> {
    return this.subscriptionGetSubscriptionSubStateFiltersResponse(
      interactiveId
    ).pipe(__map((_r) => _r.body as Array<US_Filter>));
  }

  /**
   * @param interactiveId undefined
   */
  subscriptionGetSubscriptionSubStateReportExportsResponse(
    interactiveId?: number
  ): __Observable<__StrictHttpResponse<Array<US_ReportExport>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactiveId != null)
      __params = __params.set("interactiveId", interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/GetSubscriptionSubState_ReportExports`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<US_ReportExport>>;
      })
    );
  }
  /**
   * @param interactiveId undefined
   */
  subscriptionGetSubscriptionSubStateReportExports(
    interactiveId?: number
  ): __Observable<Array<US_ReportExport>> {
    return this.subscriptionGetSubscriptionSubStateReportExportsResponse(
      interactiveId
    ).pipe(__map((_r) => _r.body as Array<US_ReportExport>));
  }

  /**
   * @param token undefined
   */
  subscriptionClearAllCacheResponse(
    token?: null | string
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (token != null) __params = __params.set("token", token.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Subscription/ClearAllCache`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param token undefined
   */
  subscriptionClearAllCache(token?: null | string): __Observable<boolean> {
    return this.subscriptionClearAllCacheResponse(token).pipe(
      __map((_r) => _r.body as boolean)
    );
  }
}

module SubscriptionService {
  /**
   * Parameters for SubscriptionGetCouponCodeDiscount
   */
  export interface SubscriptionGetCouponCodeDiscountParams {
    subscriptionTypeId?: number;
    subscriptionType?: null | string;
    subscriptionLevelId?: number;
    periodTypeId?: number;
    couponCode?: null | string;
  }

  /**
   * Parameters for SubscriptionGetTaxAmount
   */
  export interface SubscriptionGetTaxAmountParams {
    subTotal?: number;
    stateCode?: null | string;
  }

  /**
   * Parameters for SubscriptionUpdateAutoRenewCard
   */
  export interface SubscriptionUpdateAutoRenewCardParams {
    subscriptionId?: number;
    expYear?: null | string;
    expMonth?: null | string;
    ccv?: null | string;
    cc?: null | string;
  }

  /**
   * Parameters for SubscriptionSendSubscriptionInvitationEmail
   */
  export interface SubscriptionSendSubscriptionInvitationEmailParams {
    subscriptionId?: number;
    subUserId?: number;
  }
}

export { SubscriptionService };
